import router from './router'
import useFinancialStore from './store'
import financialMessages from './localization'

export default {
  router,
  useFinancialStore,
  localization: financialMessages,
}
